import { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { getTopDonors, getTopLimit } from '../config/firebase';
import type { TopDonor } from '../types';

type TopDonorsContextType = {
  donors: TopDonor[];
  topLimit: number;
  loading: boolean;
  refreshTopDonors: () => Promise<void>;
};

const TopDonorsContext = createContext<TopDonorsContextType | null>(null);

export function TopDonorsProvider({ children }: { children: ReactNode }) {
  const [donors, setDonors] = useState<TopDonor[]>([]);
  const [topLimit, setTopLimit] = useState(100);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      const limit = await getTopLimit();
      setTopLimit(limit);
      const topDonors = await getTopDonors();
      setDonors(topDonors);
    } catch (error) {
      console.error('Erreur lors de la récupération des données:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // Rafraîchir toutes les 5 minutes
    const interval = setInterval(fetchData, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <TopDonorsContext.Provider value={{ 
      donors, 
      topLimit, 
      loading,
      refreshTopDonors: fetchData 
    }}>
      {children}
    </TopDonorsContext.Provider>
  );
}

export function useTopDonors() {
  const context = useContext(TopDonorsContext);
  if (!context) {
    throw new Error('useTopDonors doit être utilisé avec TopDonorsProvider');
  }
  return context;
} 